import { BaseService } from "../../core/baseService";
import {
  AcceptStaffInvitationRequest,
  StaffInvitationAcceptanceResult,
  StaffInvitationDetails,
} from "../types/staffInvitation.types";
import { ApiResult } from "../../core/types";

export class StaffInvitationService extends BaseService {
  async getInvitationDetails(
    token: string,
  ): Promise<ApiResult<StaffInvitationDetails>> {
    const encodedToken = encodeURIComponent(token);
    return this.handleRequest(
      this.client.get<StaffInvitationDetails>(
        `/api/staff-invitations/${encodedToken}`,
      ),
    );
  }

  async acceptInvitation(
    token: string,
    payload: AcceptStaffInvitationRequest,
  ): Promise<ApiResult<StaffInvitationAcceptanceResult>> {
    const encodedToken = encodeURIComponent(token);
    return this.handleRequest(
      this.client.post<StaffInvitationAcceptanceResult>(
        `/api/staff-invitations/${encodedToken}/accept`,
        payload,
      ),
    );
  }
}
